import axios from 'axios';

export default axios.create({
  baseURL: process.env.REACT_APP_PT_PLUS_API_URL,
  // baseURL: "http://dev-ptms-service-env.eba-kbrn3c5h.us-east-1.elasticbeanstalk.com/",
  headers: {
    "Content-Type": "application/json",
  },
});